import React, { useEffect, useState } from 'react';
import Appbar from './Components/appbar';
import Menu from './Components/Menu'
import Footer from './Components/Footer';
import AssetStatus from './Components/MasterSetup/AssetStatus';
import AssetType from './Components/MasterSetup/AssetType';
import '../style/MasterSetup.css';
import { Link, useLocation } from "react-router-dom";



export default function AssetSetup(){

  const location = useLocation();
  const passedState = location.state;

  const [currentForm, setCurrentForm] = useState('assetType');
  const [isActive, setIsActive] = useState(0);

  const [username, setUsername] = useState("");
  const [rights, setRights] = useState("");

  const renderForm = () => {
    switch (currentForm) {
      case 'assetType':
        return <AssetType/>;
      case 'assetStatus':
        return <AssetStatus/>;
      default:
        return null;
    }
  };

  useEffect(()=>{
    setUsername(sessionStorage.getItem('username'))
    setRights(sessionStorage.getItem('rights'))
  })

    return(
        <>
        <Appbar username={username} rights={rights}></Appbar>
        <div className='MasterSetup'>
        <Menu username={username} rights={rights} i={"Asset"}></Menu>
        <div className='MasterSetupPage'>
          <p className='MasterSetupPageHeadLabel'>Master Setup</p>
          <div className='MasterSetupPageTabBox'>
                <button title='Asset Type' className= {isActive === 0 ? "MasterSetupPageTabBtns Active":"MasterSetupPageTabBtns"} onClick={()=>{setIsActive(0);setCurrentForm('assetType')}}> Asset Type </button>
                <button title='Asset Status' className= {isActive === 1 ? "MasterSetupPageTabBtns Active":"MasterSetupPageTabBtns"} onClick={()=>{setIsActive(1);setCurrentForm('assetStatus')}}>Asset Status</button>
                <Link state={{username:username, rights:rights }} to={"/Asset"}><button title='Asset' className='MasterSetupPageTabBtns'>Asset</button></Link>
          </div>
          <div className='MasterSetupPageContent'>
              {renderForm()}
          </div>

        </div>
        </div>
        <Footer></Footer>
        </>
    );

}